/**
 * Turn story lines into scene titles on the movie's existing pages.
 * Pages that already have artwork keep that artwork.
 */

import type { ProjectPage } from '@canvas/shared-types';
import { canvasObjectCount, createBlankPage } from '@/lib/projectPages';
import { withReelCaption } from './reelCaption';
import type { ReelBeat } from './reelTreatment';

/**
 * Rename pages to the beat lines. Add a blank page when a line has no scene.
 * Drop extra pages only when they are blank, so a drawn scene is not deleted.
 */
export function applyTreatmentPages(
  pages: ProjectPage[],
  beats: ReelBeat[],
  size: { width: number; height: number },
  options?: { embedCaption?: boolean }
): ProjectPage[] {
  const embedCaption = options?.embedCaption !== false;
  const next: ProjectPage[] = [];
  beats.forEach((beat, i) => {
    const name = beat.line.trim() || `Scene ${i + 1}`;
    const existing = pages[i];
    const named = existing
      ? { ...existing, name }
      : createBlankPage(size.width, size.height, name, i + 1);
    next.push(embedCaption ? withReelCaption(named, name) : named);
  });
  for (let i = beats.length; i < pages.length; i += 1) {
    if (canvasObjectCount(pages[i].canvasData) > 0) next.push(pages[i]);
  }
  return next;
}
